import script from "./equipment-card.vue?vue&type=script&setup=true&lang=js"
export * from "./equipment-card.vue?vue&type=script&setup=true&lang=js"

import "./equipment-card.vue?vue&type=style&index=0&id=18faeec5&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18faeec5"]])

export default __exports__